import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// async function loadLocaleMessages() {
//   let locales = []
//   const messages = {}
//   axiosIns.get('/language/languages').then(response => {
//     locales = response.data
//     locales.forEach(key => {
//       axiosIns.get(`/language/resources?locale=${key.locale}`)
//         .then(resources => {
//           messages[key.locale] = resources.data
//         })
//     })
//   })

//   return messages
// }
// function keyWord(words) {
//   return words.split('.').pop()
// }

export default new VueI18n({
  locale: 'us',
  fallbackLocale: 'al',
  silentTranslationWarn: true,
  // // messages: loadLocaleMessages(),
})
